import { render } from "./BelegAnzeige.vue?vue&type=template&id=9e85d40a&scoped=true"
import script from "./BelegAnzeige.vue?vue&type=script&lang=js"
export * from "./BelegAnzeige.vue?vue&type=script&lang=js"

import "./BelegAnzeige.vue?vue&type=style&index=0&id=9e85d40a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e85d40a"]])

export default __exports__